import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class AlertService {

//   Houston We have a Problem! 
// Heads Up!
// High Five!

  constructor(private _notificationsService: NotificationsService) { }

  public success(message) {
    const toast = this._notificationsService.success('High Five!', message, {
      timeOut: 5000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }

  public successHigh(message) {
    const toast = this._notificationsService.success('High Five!', message, {
      timeOut: 10000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }


  public error(message) {
    const toast = this._notificationsService.error('Heads Up!', message, {
      timeOut: 5000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }

  public errorHigh(message) {
    const toast = this._notificationsService.error('Heads Up!', message, {
      timeOut: 10000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }

  public warn(message) {
    const toast = this._notificationsService.warn('Heads Up!', message, {
      timeOut: 5000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }

  public warnHigh(message) {
    const toast = this._notificationsService.warn('Heads Up!', message, {
      timeOut: 10000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false,
      icons: null
    });
  }

  public info(message) {
    const toast = this._notificationsService.info('Info!', message, {
      timeOut: 5000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false
    });
  }

  public infoHigh(message) {
    const toast = this._notificationsService.info('Info!', message, {
      timeOut: 10000,
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: false
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/alert.service.ts